import {useTranslation} from "react-i18next";
import {Line} from "react-chartjs-2";
import {observer} from 'mobx-react';
import {Grid} from '@mui/material';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_HALIAS} from './TaxCommon.js';
import {TT_SPEC} from '../Util.js';
import {COMM_OK} from '../WsR2.js';

const TaxHalias = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');


	function taxHaliasRxWs(status, msg) {
		if (status !== COMM_OK) {
			console.error('taxHaliasRxWs: error ', status);
			return -1;
		}

		if (msg.cmd === 'tax' && msg.op === 'halias') {
			if (msg.result === 'OK') {
// 				console.log('taxHaliasRxWs', msg.data);
				gStorage.taxons.setHaliasData(msg.data.halias);
			} else {
				console.error('taxHaliasRxWs', msg.result);
			}
		} else {
			console.error('taxHaliasRxWs: unknown command', msg.cmd, msg.op, msg.result);
		}
	}

	function loadHaliasStats(tax) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'halias',
			data: {
				taxon: {
					id: tax.id,
				}
			}
		};

// 		console.log('loadHaliasStats', msg);
		gStorage.conn.ws.send(msg, taxHaliasRxWs);

	}

	const tax = gStorage.taxons.centerTaxon;

	if (gStorage.taxons.tab !== TAB_HALIAS || !tax || tax.t_type !== TT_SPEC)
		return null;

	if (gStorage.conn.online) {
		if (!gStorage.taxons.halias_data) {
			loadHaliasStats(tax);
			return null;
		}
	}

	if (!gStorage.taxons.halias_data || !gStorage.taxons.halias_data.length)
		return null;

	let labels = [];

	gStorage.taxons.halias_data.forEach((item, pos) => {
		if (pos % 4 === 1) {
			labels.push(Math.trunc((pos / 4)) + 1);
		} else {
			labels.push('');
		}
	});

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
			<Grid size={{xs: 12}} align={'center'}>
				<div style={{width: 300}}>
					<Line 
						data={{
							labels: labels,
							datasets: [{
								label: t('taxons.num'),
								data: gStorage.taxons.halias_data,
								borderColor: 'red',
								borderWidth: 1,
								pointRadius: 0,
								cubicInterpolationMode: 'monotone',
							}]
						}}

						options = {{
							maintainAspectRatio: true,
							title: {
								display: false,
							},
							plugins: {
								legend: { 
									display: false, 
								},
							},
							scales: {
								xAxes: {
									display: true,
									ticks: {
										autoSkip: false,
										maxRotation: 0,
										minRotation: 0
									}
								},
								y: {
									min: 0,
								}
							},
							ticks: {
								precision: 0
							}
						}}
					/>
				</div>
			</Grid>
			<Grid size={{xs: 12}} align={'center'}>
				<div style={{width: 300}}>
					&nbsp;
				</div>
			</Grid>
		</Grid>
	);
});

export default TaxHalias;
